<template>
  <p class="mt-4 mb-2 text-sm text-foundationGrey900">
    {{ text }}
  </p>
</template>

<script>
export default {
  name: "NavText",
  props: ["text"],
  mounted() {
    // console.log(this.text);
  },
};
</script>

<style></style>
